// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 16:55:22

export default {
  "id": "kings-and-queens-match-2",
  "slug": "kings-and-queens-match-2",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/33c4942945a2451189610f4effdda4eb-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/33c4942945a2451189610f4effdda4eb/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Kings and Queens Match 2",
      "description": "Kings and Queens Match 2 is one of the most anticipated Match 3 sequels! This long-awaited second chapter features 2,500+ incredible levels full of magic and adventure. Join Princess Bella on a magical adventure, matching jewels and crowns to uncover hidden treasures. Create powerful boosters like Royal Bombs, hammers, and arrows to clear obstacles and win big. Stunning graphics and an enchanting soundtrack bring the kingdom to life. Get ready for a royal journey full of fun and surprises!",
      "instructions": "Connect three or more items of the same type to remove them from the board. Every level has a goal that you have to achieve to proceed further. Focus on the goal and plan your moves carefully so that you don’t run out of them before completing the task! Use the Royal Bombs and Hammers to remove blockers and complete daily challenges for even more rewards.",
      "genres": [
        "Match-3"
      ],
      "tags": [
        "garden",
        "king",
        "match3",
        "queen"
      ]
    },
    "zh-CN": {
      "title": "国王与皇后配对2",
      "description": "《国王与皇后匹配2》是最受期待的匹配3续作之一！这部备受期待的第二章节包含2500+个充满魔法和冒险的精彩关卡。加入公主贝拉，踏上一场神奇的冒险之旅，通过匹配宝石和皇冠来发现隐藏的宝藏。创建强大的增强器，如皇家炸弹、锤子和箭，清除障碍并赢得大奖。惊人的画面和迷人的配乐让王国栩栩如生。准备开始一段充满乐趣和惊喜的皇室之旅！",
      "instructions": "连接三个或更多相同类型的物品以从板上移除它们。每个关卡都有一个你必须达到的目标才能继续前进。专注于目标，仔细规划你的动作，以免在完成任务之前用尽它们！使用皇家炸弹和锤子来移除阻碍物并完成每日挑战以获得更多奖励。",
      "genres": [
        "匹配3"
      ],
      "tags": [
        "花园",
        "国王",
        "三消",
        "王后"
      ]
    },
    "zh-TW": {
      "title": "國王與皇后配對2",
      "description": "《国王與王后配對2》是最受期待的配對3遊戲續作之一！這個期待已久的第二篇章包含超過2,500個令人驚艷的關卡，滿滿的魔法與冒險。加入公主貝拉，在魔法冒險中配對寶石和王冠，揭露隱藏的寶物。創造強大的加強器，如皇家炸彈、鐵锤和箭矢，清除障礙，獲勝。驚人的圖像和迷人的音樂讓王國栩栩如生。準備好開啟一場充滿快樂與驚喜的皇家旅程吧！",
      "instructions": "將三個或以上的同類物品連結起來即可將其從遊戲板中移除。每個關卡都有必須達成的目標，達成後才能繼續進行。專注於目標，謹慎規劃你的步驟，以免在完成任務前耗盡它們！使用皇家炸彈和鍵槌移除阻礙物，並完成每日挑戰，以獲得更多的獎勵。",
      "genres": [
        "匹配3"
      ],
      "tags": [
        "花園",
        "國王",
        "三消對戰",
        "王后"
      ]
    },
    "zh-HK": {
      "title": "王與王后配對2",
      "description": "Kings and Queens Match 2 為最受期待的一款 Match 3 系列續作！這個長期以來的續集包含超過 2,500 個精彩關卡，充滿魔法與冒險。加入公主貝拉於魔法冒險，配對珠寶與王冠以發現隱藏的財寶。製造強大的強化道具，如皇家炸彈、鐵鎚及弓箭，清除障礙並獲得豐厚獎勵。驚艷的圖像和迷人的音樂讓王國栩栩如生。準備好開啟一場充滿歡樂與驚喜的皇家之旅！",
      "instructions": "連結三個或以上的同類物品以將其從遊戲板中移除。每個關卡都有目標，您必須達成目標才能繼續進行。專注於目標，謹慎規劃您的步驟，以免在完成任務前用盡它們！使用皇家炸彈和鐵錘移除阻礙物，並完成每日挑戰以獲得更多的獎勵。",
      "genres": [
        "三消配對"
      ],
      "tags": [
        "花園",
        "皇帝",
        "匹配3",
        "皇后"
      ]
    },
    "ja": {
      "title": "キングスアンドクイーンズマッチ2",
      "description": "キングスアンドクイーンズマッチ2は、最も待望のマッチ3シリーズの一つです！この長い間待ちに待った第2章には、魔法と冒険に満ちた2,500以上の驚異的なレベルが満載です。プリンセスベラに加わり、宝石と王冠をマッチさせて隠された宝物を発見する魔法の冒険に参加しましょう。ロイヤルボム、ハンマー、矢などの強力なブースターを作成し、障害物をクリアして大きな勝利を収めましょう。圧巻のグラフィックと魅力的なサウンドトラックが王国を蘇らせます。楽しさと驚きに満ちた王位の旅に準備하세요！",
      "instructions": "同じ種類のアイテムを3つ以上結合してボードから削除します。各レベルには進むために達成しなければならない目標があります。目標に集中し、慎重に動作を計画して、タスクを完了する前にリソースを使い果たさないようにしましょう！ロイヤル爆弾やハンマーを使ってブロッカーを取り除き、さらなる報酬を得るために日々の挑戦を完了してください。",
      "genres": [
        "マッチ3"
      ],
      "tags": [
        "庭園",
        "王",
        "マッチ3",
        "王妃"
      ]
    },
    "ko": {
      "title": "왕과 여왕 매치 2",
      "description": "キングズ 앤 퀸즈 매치 2는 가장 기대되는 매치 3 시퀀셜 중 하나입니다! 이 오랫동안 기다려온 두 번째 장은 마법과 모험 가득한 2,500+의 놀라운 레벨을 특징으로 합니다. 공주 벨라와 함께 마법의 모험에 떠나고, 보석과 왕관을 매칭하여 숨겨진 보물을 발견하세요. 장애물을 제거하고 큰 이익을 얻기 위해 왕실 지뢰, 막대기, 화살과 같은 강력한 부스터를 만들어보세요. 경이로운 그래픽과 매혹적인 사운드트랙이 왕국을 살아나게 합니다. 즐거움과 놀라움 가득한 왕실 여행에 준비하세요!",
      "instructions": "동일한 유형의 3개 이상의 아이템을 연결하여 게임 보드에서 제거하세요. 각 레벨마다 진행하기 위해 달성해야 하는 목표가 있습니다. 목표에 집중하고, 그 목표를 달성하기 전에 아이템이 모두 소진되지 않도록 주의 깊게 움직이세요! 로얄 지뢰와 망치를 사용하여 블록을 제거하고, 더 많은 보상을 받기 위해 일일 도전 과제를 완료하세요.",
      "genres": [
        "매치3"
      ],
      "tags": [
        "정원",
        "왕",
        "매치3",
        "왕비"
      ]
    },
    "fr": {
      "title": "Le Match des Rois et des Reines 2",
      "description": "Kings and Queens Match 2 est l'un des suites de jeux Match 3 les plus attendues ! Ce deuxième épisode tant attendu comporte plus de 2 500 niveaux incroyables, pleins de magie et d'aventure. Rejoignez la princesse Bella dans une aventure magique, matchez des joyaux et des couronnes pour découvrir des trésors cachés. Créez des boosters puissants comme des bombes royales, des marteaux et des flèches pour enlever les obstacles et gagner gros. Des graphismes époustouflants et une bande originale enchantante donnent vie au royaume. Préparez-vous à un voyage royal plein de fun et de surprises !",
      "instructions": "Connectez trois ou plus d'items du même type pour les supprimer du plateau. Chaque niveau a un objectif à atteindre pour continuer. Concentrez-vous sur l'objectif et planifiez vos mouvements avec soin afin de ne pas manquer de ceux-ci avant de terminer la tâche ! Utilisez les Bombes Royales et les Marteaux pour supprimer les bloquants et accomplir les défis quotidiens pour obtenir encore plus de récompenses.",
      "genres": [
        "Criss-Croise 3"
      ],
      "tags": [
        "jardin",
        "roi",
        "match3",
        "reine"
      ]
    }
  }
};
